import useSWR from "swr";
import { appConfig } from "../appConfig";
import { useMainDict } from "./useTranslation";
import { fetcher } from "../fetcher";
import { BlocksContent } from "@strapi/blocks-react-renderer";

export type PrivacyPolicyType = {
  id: number;
  attributes: {
    createdAt: string;
    updatedAt: string;
    publishedAt: string;
    title: string;
    links: { href: string; label: string }[];
    text: BlocksContent;
  };
};

type PrivacyPolicyResponseType = {
  data: PrivacyPolicyType;
  meta: {};
};

const getApiRoute = (language: string) =>
  `/privacy-policy?locale=${language}&populate=*`;

export async function preFetchPrivacyPolicy(language: string) {
  try {
    const apiRoute = getApiRoute(language);

    const data = await fetcher<PrivacyPolicyResponseType>(apiRoute);

    return { [apiRoute]: data };
  } catch (error) {
    console.error(error);
    return null;
  }
}

export function usePrivacyPolicy() {
  const { language } = useMainDict();

  const { data, isLoading } = useSWR<PrivacyPolicyResponseType>(
    getApiRoute(language),
    {
      refreshInterval: 0,
    
    }
  );

  return { privacyPolicy: data?.data, isLoading };
}
